export const ProjectsData = {
    data: [
        {
            title: 'fire-ecommerce.io',
            alias: 'fire-ecommerce-io',
            description: 'ecommerce web app built with react and firebase as the DB',
            tags: ['react', 'firebase', 'bootstrap', 'ecommerce'],
            gitUrl: 'https://github.com/kelvink96/fire-ecommerce-io',
            liveUrl: 'https://fire-ecommerce-io.vercel.app/'
        },
        {
            title: 'memoir.io',
            alias: 'memoir.io-cms',
            description: 'article site built with react (nextjs) as frontend and graphcms',
            tags: ['react', 'graphcms', 'nextjs', 'tailwind', 'memoir', 'blogs'],
            gitUrl: 'https://github.com/kelvink96/memoir.io-cms',
            liveUrl: 'http://memoir-io-cms.vercel.app/'
        },
        {
            title: 'cryptoverse',
            alias: 'cryptoverse',
            description: 'an application to fetch cyrptos and its respective news and exchanges',
            tags: ['react', 'antd', 'cryptos', 'crypto'],
            gitUrl: 'https://github.com/kelvink96/cryptoverse',
            liveUrl: 'http://cryptoverse-nu.vercel.app/'
        },
        {
            title: 'hotels.com',
            alias: 'hotel-booking-site',
            description: 'a responsive hotel website, built with html and bootstrap5',
            tags: ['html', 'bootstrap', 'hotels.com', 'hotels'],
            gitUrl: 'https://github.com/kelvink96/hotel-booking-site',
            liveUrl: 'http://hotel-booking-site-one.vercel.app/'
        },
        {
            title: 'jobs.lookr',
            alias: 'job-finder-site',
            description: 'a job search/finder website, built with html and bootstrap5',
            tags: ['html', 'bootstrap', 'job finder', 'job.lookr'],
            gitUrl: 'https://github.com/kelvink96/job-finder',
            liveUrl: 'http://job-finder-alpha.vercel.app/'
        },
        {
            title: 'tasks.io',
            alias: 'task-manager-site',
            description: 'a task management website, built with html and bootstrap5',
            tags: ['html', 'bootstrap', 'task management', 'tasks.io'],
            gitUrl: 'https://github.com/kelvink96/task-manager-site',
            liveUrl: 'http://task-manager-site-opal.vercel.app/'
        },
        {
            title: 'netabank',
            alias: 'banking-challenge',
            description: 'a bandking institution website, built with react and mantine',
            tags: ['react', 'mantine', 'banking', 'banking site'],
            gitUrl: 'https://github.com/kelvink96ltd/banking-challenge',
            liveUrl: 'https://kelvink96ltd.github.io/banking-challenge/'
        },
        {
            title: 'e-ducate',
            alias: 'e-ducate',
            description: 'an education institution website, built with react and bootstrap5',
            tags: ['react', 'bootstrap', 'education site', 'education'],
            gitUrl: 'https://github.com/kelvink96/e-ducate',
            liveUrl: 'http://e-ducate.vercel.app/'
        },
        {
            title: 'acevpn',
            alias: 'acevpn',
            description: 'Uplabs VPN UI challenge - https://www.uplabs.com/challenges/vpn-app-challenge',
            tags: ['react', 'mantine', 'vpn site', 'landing page'],
            gitUrl: 'https://github.com/kelvink96ltd/vpn-challenge',
            liveUrl: 'https://62b8ada9f345057c4fb44d4c--fantastic-speculoos-9fcd96.netlify.app/'
        },
        {
            title: 'm-network',
            alias: 'm-network',
            description: 'M-network ISP website',
            tags: ['react', 'bootstrap', 'ISP site'],
            gitUrl: '',
            liveUrl: 'https://mnetwork.co.ke/'
        }
    ]
}
